import type {
  ToolErrorCode,
  ToolOperation,
} from '@saas-pages/shared/public/runtime'

interface ActiveOperation {
  requestId: number
  operation: ToolOperation
}

/** Keeps an accepted analytics operation paired with exactly one terminal event. */
export class ToolOperationLifecycle {
  private active: ActiveOperation | null = null

  start(requestId: number, operation: ToolOperation): void {
    this.cancel()
    this.active = { requestId, operation }
  }

  success(requestId: number, durationMs: number): void {
    if (this.active?.requestId !== requestId) return
    const { operation } = this.active
    this.active = null
    operation.success(durationMs)
  }

  error(requestId: number, errorCode: ToolErrorCode): void {
    if (this.active?.requestId !== requestId) return
    const { operation } = this.active
    this.active = null
    operation.error(errorCode)
  }

  cancel(): void {
    if (!this.active) return
    const { operation } = this.active
    this.active = null
    operation.error('cancelled')
  }
}
